/**
 * File: TourButton.tsx
 * Path: apps/admin/src/modules/layout/components/TourButton.tsx
 * Description: The small ? icon in a page header. It opens the Help dialog
 * with that page's tutorials.
 */

import React from "react";
import { HelpCircle } from "lucide-react";
import { useTourButtonController } from "@/modules/layout/hooks/useTourButtonController";

export const TourButton: React.FC = () => {
  const { openHelp } = useTourButtonController();
  return (
    <button
      type="button"
      aria-label="Help for this page"
      title="Help for this page"
      onClick={openHelp}
      className="inline-flex h-11 w-11 items-center justify-center border border-border/60 text-muted-foreground hover:border-primary hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <HelpCircle className="h-5 w-5" aria-hidden />
    </button>
  );
};
